import React from "react";
import { FullScreenError } from "./FullScreenError";
import { telemetry } from "@/utilities/telemetry";
import * as Sentry from "@sentry/gatsby";

type ErrorBoundaryProps = {
  children?: React.ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  public state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error) {
    if (typeof window === "undefined") return;
    console.error(error);
    telemetry.appCrash();
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <FullScreenError
          title="Shoot!"
          message="Something went wrong and our developers are looking into it..."
        />
      );
    }

    return this.props.children;
  }
}
